module.exports = "https://img.zhijierongxing.com/saas/img/rmb_icon1.4078918b.png";